import {Paper, Select} from "@mantine/core";
import {Row, Col} from "../../components/Flex/Flex";
import Icon from "../../components/Icon/Icon";
import IconMap from "../../components/Icon/IconMap";
import {useEntityTypes} from "../../utils/api";
import {useMemo, useState} from "react";


export default function CreatureSpawn() {

    const {creatures, terrains} = useEntityTypes(['creatures', 'terrains'], true);

    const [selectedTerrain, setSelectedTerrain] = useState<string | null>(null);
    const [selectedCreature, setSelectedCreature] = useState<CreatureType | null>(null);

    const possibleCreatures = useMemo(() => {
        if (selectedTerrain) {
            return creatures.filter(c => c.spawnTerrains.some(s => s.id === selectedTerrain));
        }
        return creatures;
    }, [selectedTerrain, creatures]);


    return (
        <div className="w-full">
            <title>Creature Spawn Charts</title>
            <Row align="center">
                <Col><h1>Creatures</h1></Col>
                <Col grow={1}/>
                <Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Creatures" target="_blank"><Icon icon={IconMap.SwcRules}/> Full
                    rules</a></Col>
            </Row>
            <Paper className="mb-3">
                <h2 className="mt-0">By Terrain</h2>
                <Select data={terrains.map(i => ({value: i.id, label: i.name}))} value={selectedTerrain} onChange={setSelectedTerrain}/>

                {selectedTerrain && (
                    possibleCreatures.length > 0 ?
                        <div className="flex flex-row flex-wrap mt-2" style={{gap: '1rem'}}>
                            {possibleCreatures.map(c => <CreatureBlock key={c.id} creature={c}/>)}
                        </div>
                        : <i>No creatures spawn on this terrain</i>
                )}

            </Paper>
            <Paper className="mb-3">
                <h2 className="mt-0">By Creature</h2>

                <Row>
                    <Col grow={1}>
                        <Select data={creatures.map(i => ({value: i.id, label: i.name}))} value={selectedCreature?.id} searchable clearable
                                  onChange={(value) => setSelectedCreature(creatures.find(c => c.id === value) || null)}/>
                    </Col>
                    <Col grow={1}>
                        {selectedCreature && <img src={selectedCreature.images.small} alt={selectedCreature.name} />}
                    </Col>
                </Row>


                {selectedCreature && (
                    <div className="flex flex-row flex-wrap mt-2" style={{gap: '1rem'}}>
                        {selectedCreature.spawnTerrains.map(t => <TerrainBlock key={t.id} terrain={t} terrains={terrains} creatures={creatures}/>)}
                    </div>
                )}


            </Paper>
            {/*<Card>*/}
            {/*    <h2 className="mt-0">Full Matrix</h2>*/}
            {/*    <DataTable value={creatures}>*/}
            {/*        <Column field="name" header="Creature" body={bodyCreatureName}/>*/}
            {/*        {terrains.map(t =>*/}
            {/*            <Column*/}
            {/*                header={t.name}*/}
            {/*                body={row => <TerrainCell terrain={t} creature={row}/>}/>*/}
            {/*        )}*/}
            {/*    </DataTable>*/}
            {/*</Card>*/}
        </div>
    )
}


const CreatureBlock = ({creature}: { creature: CreatureType }) => {
    return (
        <div className="flex flex-column" style={{width: 100}}>
            <img src={creature.images.small} alt={creature.name} width={100} height={100}/>
            <b>{creature.name}</b>
            <i>{creature.class}</i>
        </div>
    )
}

const TerrainBlock = ({terrain, terrains, creatures}: { terrain: SpawnTerrain, creatures: CreatureType[], terrains: Terrain[] }) => {
    const t = terrains.find(t => t.id === terrain.id);
    const tot = creatures.reduce((tot, el) => el.spawnTerrains.some(s => s.id === terrain.id) ? tot + 1 : tot, 0)
    return (
        <div className="flex flex-column" style={{width: 100}}>
            <img src={t?.images.small} alt={terrain.name} width={100} height={100}/>
            <b>{terrain.name}</b>
            <i>Total Creatures: {tot}</i>
        </div>
    )
}
